import { http } from '../index';

export const getNotificationsList = params => {
  return http
    .get('/notifications/list', { params })
    .then(res => res.data)
    .catch(error => error.response.data);
};

export const getUnreadNotificationsCount = () => {
  return http
    .get('/notifications/new')
    .then(res => res.data)
    .catch(error => error.response.data);
};

export const markNotificationAsRead = id =>
  http
    .patch(`/notifications/${id}/read`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const markNotificationAsUnread = id =>
  http
    .patch(`/notifications/${id}/unread`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteNotification = id =>
  http
    .delete(`/notifications/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const bulkMarkNotificationsAsRead = ids =>
  http
    .post('/notifications/bulk/read', { ids })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const bulkDeleteNotifications = ids =>
  http
    .post('/notifications/bulk/delete', { ids })
    .then(res => res.data)
    .catch(error => error.response?.data || error);
